module.exports = __webpack_public_path__ + "img/pain3.svg";